import {useEffect, useRef} from "react";
import Header from "../components/Header/Header";
import MainTactics from "../components/MainTactics/MainTactics";
import {MatchService} from "../services/Match.Service";
import {OnlineService} from "../services/Online.Service";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {match} from "../atoms/match";
import {attacking} from "../atoms/attacking";
import {useParams} from "react-router-dom";
import {LexiconService} from "../services/Lexicon.Service";
import {time} from "../atoms/time";
import {referee} from "../atoms/referee";

export default function Tactics() {
  const [matchData, setMatchData] = useRecoilState(match);
  const { analyse_status } = useRecoilValue(match);
  const intervalRef = useRef<NodeJS.Timer | number | null>(null);
  let { id } = useParams();
  const times = useRecoilValue(time);

  const setAttackingData = useSetRecoilState(attacking);
  const setRefereeData = useSetRecoilState(referee);

  const fetchData = async () => {
    const response = await MatchService.getMatch(Number(id));
    const newData = await response.data;
    setMatchData(newData);
  };

  const fetchAttacking = async () => {
    try {
      const response = await OnlineService.getAttacking(Number(id));
      const result = response.data;
      if (result?.home?.metrics && result?.away?.metrics) {
        setAttackingData(result);
      } else {
        console.warn("Attacking data has unexpected shape, skipping update");
      }
    } catch (error) {
      console.error("Failed to fetch attacking data:", error);
    }
  };
  const fetchRefereeData = async () => {
    try {
      const response = await OnlineService.getReferee(Number(id));
      const result = response.data;
      if (result?.home && result?.away && result?.referee) {
        setRefereeData(result);
      } else {
        console.warn("Referee data has unexpected shape, skipping update");
      }
    } catch (error) {
      console.error("Failed to fetch referee data:", error);
    }
  };

  useEffect(() => {
    const fetchLexics = async () => {
      const response = await LexiconService.getLexic(
        localStorage.getItem("i18nextLng") || "en"
      );
      const newData = await response.data;
      localStorage.setItem("lexics", JSON.stringify(newData));
    };
    fetchData();
    fetchAttacking();
    fetchRefereeData();
    fetchLexics();
  }, []);

  // useEffect(() => {
  //   if (analyse_status === 2){
  //     const interval = setInterval(fetchData, times.time);
  //     intervalRef.current = interval;
  //   }
  // },[analyse_status])

  // useEffect(() => {
  //   if (analyse_status !== 2 && analyse_status !== 0) {
  //     return () => {
  //       if (intervalRef.current !== null) {
  //         clearInterval(intervalRef.current as NodeJS.Timer);
  //       }
  //     };
  //   }
  // }, [matchData]);

  const fetchAll = async () => {
    await fetchData();
    await fetchAttacking();
    await fetchRefereeData();
  };

  useEffect(() => {
    if (analyse_status === 2) {
      fetchAll();

      intervalRef.current = setInterval(fetchAll, times.time);

      return () => {
        if (intervalRef.current !== null) {
          clearInterval(intervalRef.current as NodeJS.Timer);
        }
      };
    }
  }, [analyse_status, times.time]);

  return (
    <div className="bg-[#EBF1FF] dark:bg-[#0F1521] h-full">
      <Header />
      <MainTactics />
    </div>
  );
}
